export enum InputSizes {
  Default = 'Default',
  Small = 'Small',
  Large = 'Large'
}
